import {
  isValidUploadedImageSize,
  isValidUploadedImageFormat,
  isRequired
} from 'utils/validators';

const validate = values => {
  const errors = {};

  if (isRequired(values.privacyPolicy || '', true)) {
    errors.privacyPolicy = 'Privacy policy is required';
  }

  if (isRequired(values.termsAndConditions || '', true)) {
    errors.termsAndConditions = 'Terms and conditions is required';
  }

  if (values.coverPhoto) {
    if (isValidUploadedImageSize(values.coverPhoto || '', true)) {
      errors.coverPhoto = 'Your file exceeded the size limit';
    } else if (isValidUploadedImageFormat(values.coverPhoto || '', true)) {
      errors.coverPhoto = `File could not be uploaded because the format is not supported. Please upload the file with the format png, jpg, jpeg`;
    }
  }

  if (values.languages) {
    if (values.languages.length === 0) {
      errors.languages = 'Select at least one language';
    }
  }
  return errors;
};

export default validate;
